import * as api from "../../shared/api";
import * as biz_data_helper from "../../shared/biz_data_helper";

const content_type = "SEI_CustTable2";

const create = function () {
  return {
    content_type: "muji",
    age: 29
  };
};

const descriptor = {
  name: {
    type: "string",
    required: true,
    validator: (rule, value) => value === "muji"
  },
  age: {
    type: "number",
    asyncValidator: (rule, value) => {
      return new Promise((resolve, reject) => {
        api
          .request({
            url: biz_data_helper.get_endpoint("test_fetch").url,
            parameters: {
              c: "a666"
            }
          })
          .then(res => {


            if (value == res.data[0].echo) {
              resolve(res);
            } else {
              reject("测试没通过");
            }
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  }
};

const biz_data = new biz_data_helper.base_entity_helper(
  content_type,
  create,
  descriptor
);

const fields = [{
  key: "id",
  label: "编号",
  sortable: true
},
{
  key: "AccountNum",
  label: "客户账户",
  sortable: true,
},
{
  key: "dispUsedCreditAmount",
  label: "已用信用额度",
  sortable: true,
  type: "number",
},
{
  key: "dispopenInvoiceBalanceMSTDue0",
  label: "未到期的应收",
  sortable: true,
  stype: "number",
},
{
  key: "dispopenInvoiceBalanceMSTDue_N",
  label: "超15天内的应收",
  sortable: true,
  type: "number",
},
{
  key: "dispopenInvoiceBalanceMSTDueAbove_N",
  label: "超15天及以上的应收",
  sortable: true,
  type: "number",
}, {
  key: "dispopenInvoiceBalanceMSTDue30",
  label: "超30天内的应收",
  sortable: true,
  type: "number",
}, {
  key: "dispopenInvoiceBalanceMSTDue31_60",
  label: "超31至60天的应收",
  sortable: true,
  type: "number",
},
{
  key: "dispopenInvoiceBalanceMSTDue60Above",
  label: "超60天的应收",
  sortable: true,
  type: "number",
}
];

const dataForm = {};
///前端验证
const rules = {};

const methods = {
  ///get
  async getData(_params) {
    let result = await biz_data
      .selectAction({
        params: _params,
        fields: _.map(fields, "key")
      })
      .run();

    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data;
    } else {
      return null;
    }
  },
};
export {
  biz_data, dataForm, fields, methods,
  rules
};

